const i18n = {
	accessToAppeals: {
		0 : 'Доступ да зваротаў',
		1 : 'Доступ к обращениям'
	},
	account: {
		0 : 'Сардэчна запрашаем, ',
		1 : 'Добро пожаловать, '
	},
	apealsActions: {
		0 : 'Дзеянні з зваротамі',
		1 : 'Действия с обращениями'
	},
	appealRequests: {
		0 : 'Запыты арганізацыі',
		1 : 'Запросы организации'
	},
	appealsActions: {
		0 : 'Звароты',
		1 : 'Обращения'
	},
	appealsCollective: {
		0 : 'Спіс незавершаных калектыўных зваротаў',
		1 : 'Список незавершённых коллективных обращений'
	},
	appealsControl: {
		0 : 'Спіс зваротаў на кантролі арганізацыі',
		1 : 'Список обращений на контроле организации'
	},
	appealsIn: {
		0 : 'Спіс пададзеных у арганізацыю зваротаў',
		1 : 'Список поданных в организацию обращений'
	},
	appealsYou: {
		0 : 'Спіс пададзеных вамі зваротаў',
		1 : 'Список поданных вами обращений'
	},
	appointYou: {
		0 : 'Спіс прызначаных на вас зваротаў',
		1 : 'Список назначенных на вас обращений'
	},
	archive: {
		0 : 'Справа',
		1 : 'Дело'
	},
	contentManagement: {
		0 : 'Кіраванне кантэнтам',
		1 : 'Управление контентом'
	},
	createAppeal: {
		0 : 'Стварыць РКК',
		1 : 'Создать РКК'
	},
	management: {
		0 : 'Адміністраванне',
		1 : 'Администрирование'
	},
	messages: {
		0 : 'Паведамлення',
		1 : 'Сообщения'
	},
	messagesToAmin: {
		0 : 'Паведамлення адміністратару',
		1 : 'Сообщения администратору'
	},
	notifications: {
		0 : 'Апавяшчэнні',
		1 : 'Уведомления'
	},
	nsiModify: {
		0 : 'Кіраванне НДI',
		1 : 'Управление НСИ'
	},
	orgManagement: {
		0 : 'Кіраванне арганізацыяй',
		1 : 'Управление организацией'
	},
	profile: {
		0 : 'Мой профіль',
		1 : 'Мой профиль'
	},
	register: {
		0 : 'Зарэгістраваць карыстальніка',
		1 : 'Зарегистрировать пользователя'
	},
	rolesTitle: {
		0 : 'Дадатковыя ролі карыстальніка',
		1 : 'Дополнительные роли пользователя'
	},
	services: {
		0 : 'Сервісы',
		1 : 'Сервисы'
	},
	submitAppeal: {
		0 : 'Падаць зварот',
		1 : 'Подать обращение'
	},
	tasks: {
		0 : 'Задачы',
		1 : 'Задачи'
	},
	user: {
		0 : "Карыстальнік",
		1 : "Пользователь"
	},
	users: {
		0 : 'Карыстальнікі',
		1 : 'Пользователи'
	},
	workSchedule: {
		0 : 'Час працы',
		1 : 'Время работы'
	},
	reOrgAppealMissions: {
		0 : 'Даручэнні',
		1 : 'Поручения'
	}
}

export default i18n
